export const SUPPLIER_TYPES = [
  {name: 'Lieferant', label: 'Lieferant', default: false},
  {name: 'Standort', label: 'Standort', default: true},
  {name: 'Fahrzeug', label: 'Fahrzeug', default: false},
  {name: 'Klient', label: 'Klient', default: false},
];


// WEBPACK FOOTER //
// ./src/app/store-management/supplier-types.enum.ts